/** Leave the app for a page on another site (e.g. the payment provider's checkout). */
export const openExternalPage = (url: string): void => {
  window.location.assign(url);
};
